// export const siteKey = '6Lct4GAUAAAAADSBBcoFpzN5bfwofgcjjgzrPGTd'; // ЦС
export const siteKey = '6LdWyGAUAAAAAJTKhnyQphS4LLpcWh7qkn6lJ-A-';
